import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isMagicLink, completeMagicLink } from "../../firebase/auth.js";

// Landing point for the email magic link (configured as /auth/finish).
// Completes sign-in, then forwards to ?next (e.g. the claim-finish page).
export default function AuthFinish() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Signing you in…");

  useEffect(() => {
    const next = params.get("next") || "/app";
    (async () => {
      try {
        if (isMagicLink()) {
          await completeMagicLink();
        }
        navigate(next, { replace: true });
      } catch (e) {
        setStatus("Sign-in link invalid or expired. Please try again.");
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="container center" style={{ paddingTop: 120 }}>
      <p className="muted">{status}</p>
    </div>
  );
}
